import { gql, useMutation } from 'urql';

export const CREATE_TICKETS = gql`
  mutation createTickets($participantIds: [Int!], $eventId: Int!, $segmentId: Int) {
    createTicket(
      input: { checked: false, active: true }
      participantIds: $participantIds
      eventId: $eventId
      segmentId: $segmentId
    ) {
      tickets {
        id
        ticketUuid
        checked
        active
        createdAt
        updatedAt
        ticketSegmentId
      }
    }
  }
`;

export const useCreateTickets = () => {
  const [{ data, error }, executeMutation] = useMutation(CREATE_TICKETS);

  const createTickets = (variables: { participantIds: number[]; eventId: number; segmentId?: number }) => {
    return executeMutation(variables);
  };

  return { data, error, createTickets };
};
